import { render, staticRenderFns } from "./IncidentBadge.vue?vue&type=template&id=bae422d8&scoped=true&"
import script from "./IncidentBadge.vue?vue&type=script&lang=js&"
export * from "./IncidentBadge.vue?vue&type=script&lang=js&"
import style0 from "./IncidentBadge.vue?vue&type=style&index=0&id=bae422d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae422d8",
  null
  
)

export default component.exports